<template>
  <div>
    <a v-if="data.slug && data.slug.startsWith('https')" :href="data.slug" class="lnk">
      {{ data.name }}
    </a>
    <nuxt-link v-else-if="data.slug" :to="link" class="lnk">
      {{ data.name }}
    </nuxt-link>
    <template v-else>
      {{ data.name }}
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, required: true },
    parentSlug: { type: String, default: '', required: false },
  },
  computed: {
    link() {
      let url = '';
      const pSlug = this.parentSlug.replace(/\//g, ''); // remove /

      if (this.parentSlug) {
        url = `/${pSlug}/${this.data.slug}/`;
      } else if (this.data.slug) {
        url = this.data.slug;
      }

      return url;
    },
  },
};
</script>
